import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

const Toast = ({ visibility, children }) => {
  const [state, setState] = useState(false)

  useEffect(() => setState(visibility), [visibility])

  return (
    <div className="z-[11] p-4 right-0 top-0 fixed box-border block">
      <div
        className={`w-[350px] max-w-full text-sm pointer-events-auto bg-white/85 bg-clip-padding border border-black/10 box-border shadow-[0_0.5rem_1rem_rgba(0,0,0,.15)] rounded flex transition-opacity duration-300 ${
          state ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div className="p-3 break-words box-border block flex-1">{children}</div>
        <button
          onClick={() => setState(false)}
          className="box-content w-[1em] h-[1em] my-auto mr-2 p-[0.25em] text-black bg-transparent bg-[url('data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2016%2016%27%20fill=%27%23000%27%3e%3cpath%20d=%27M.293.293a1%201%200%20011.414%200L8%206.586%2014.293.293a1%201%200%20111.414%201.414L9.414%208l6.293%206.293a1%201%200%2001-1.414%201.414L8%209.414l-6.293%206.293a1%201%200%2001-1.414-1.414L6.586%208%20.293%201.707a1%201%200%20010-1.414z%27/%3e%3c/svg%3e')] bg-center bg-[length:1em_auto] bg-no-repeat border-0 rounded opacity-50"
        />
      </div>
    </div>
  )
}

Toast.propTypes = {
  visibility: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
}

export default Toast
